var module = angular.module('ngPopover', []);

module.provider('ngPopover', function () {
	//Environment variables
	var open = false;
	var smallScreenBreakpoint = 500;
	var maximizeMargin = 0;
	var currentTarget;
	var margin = 15;
	
	/*$(document).on('click', function (e) {
		if (open) {
			var inOverlay = overlayClasses.some(function(cls) {
				return $(cls).has(e.target).length != 0;
			});
			if (!$('#ng-popover').is(e.target) && $('#ng-popover').has(e.target).length == 0 && !inOverlay) {

				var fadeOutTime = 200;
				var target = $(e.target);

				if (target.attr('ng-popover') || target.parents(['ng-popover'])){
					fadeOutTime = 0;
				}
				
				$('#ng-popover').fadeOut(fadeOutTime, function() {
					$(this).remove();
					open = false;

					if (currentTarget != e.target && (target.attr('ng-popover') || target.parents(['ng-popover']))) {
						target.trigger('click');
					}
				});
			}
		}
	});*/

	var getDefaultOptions = () => {
		return {
			smallScreenBreakpoint : 500,
			maximizeMargin : 0,
			overlayClasses : [],
			placement : 'bottom',
			maximize :  false,
			title : '',
			useParentWidth : false,
			anchorSelector : '',
			maxWidth : null,
		}
	};

	var calcPosition = function(element, placement, maximize, useParentWidth, anchorSelector, maxWidth, minWidth) {

		var elementPosition = $(element).offset();
		var elementWidth = $(element).outerWidth();
		var elementHeight = $(element).outerHeight();
		var windowWidth = $(window).width();
		
		var maxWidthToSet = maxWidth > windowWidth ? windowWidth : maxWidth;
		var minWidthToSet = minWidth > windowWidth ? windowWidth : minWidth;
		
		$('#ng-popover').css({
			maxWidth: maxWidthToSet ? maxWidthToSet : 'initial',
			minWidth: minWidthToSet ? minWidthToSet : 'initial'
		});
		
		var popoverWidth  = $('#ng-popover').outerWidth();
		var popoverHeight = $('#ng-popover').outerHeight();

		if (useParentWidth) {
			popoverWidth = elementWidth;
			$('#ng-popover').css({
				width: popoverWidth
			});
		}

		var win = $(window);
		var viewport = {
			top : win.scrollTop(),
			left : win.scrollLeft()
		};
		viewport.right = viewport.left + win.width();
		viewport.bottom = viewport.top + win.height();

		var pos;
		if (placement === 'left') {
			pos = {
				left: elementPosition.left - popoverWidth, 
				top: elementPosition.top + elementHeight/2 - popoverHeight / 2 
			};	
		}
		if (placement === 'right') {
			pos = {
				left: elementPosition.left + elementWidth, 
				top: elementPosition.top + elementHeight/2 - popoverHeight / 2	
			};			
		}
		if (placement === 'bottom') {
			let left = elementPosition.left + elementWidth/2 - popoverWidth / 2;
			pos = {
				left: left < 0 ? 0 : left, 
				top: elementPosition.top + elementHeight
			};			
		}
		if (placement === 'top') {
			pos = {
				left: elementPosition.left - popoverWidth / 2, 
				top: elementPosition.top - popoverHeight	
			};			
		}

		if (placement === 'left' || placement === 'right') {
			var adjustedTop = 0;
			if (pos.top + popoverHeight > viewport.bottom || pos.top < viewport.top) {
				adjustedTop = Math.min(pos.top, pos.top + popoverHeight - viewport.bottom);
				pos.top -= adjustedTop;

				$('#ng-popover .arrow').css({
					top: adjustedTop + popoverHeight / 2
				});
			}
		}

		if (placement === 'bottom' || placement === 'top') {
			var adjustedLeft = 0;
			if (pos.left + popoverWidth > viewport.right) {
				adjustedLeft = Math.min(pos.left, pos.left + popoverWidth - viewport.right);
				pos.left -= (adjustedLeft + margin);

				$('#ng-popover .arrow').css({
					left: adjustedLeft + margin + elementPosition.left + elementWidth/2
				});
			}
		}

		if (anchorSelector) {
			var $anchor = $(element).find(anchorSelector);
			anchorPosition = $anchor.offset();
			anchorWidth = $anchor.outerWidth()

			$('#ng-popover .arrow').css({
				left: anchorPosition.left - elementPosition.left + anchorWidth / 2 - 1
			});
		}

		if (windowWidth < smallScreenBreakpoint && maximize) {
			var padding = popoverWidth - $('#ng-popover').width();
			$('#ng-popover').width(windowWidth - padding - 2 * maximizeMargin);
			pos.left = maximizeMargin;

			if (placement === 'bottom' || placement === 'top') {
				$('#ng-popover .arrow').css({
					left: elementPosition.left + elementWidth / 2 - maximizeMargin
				});				
			}
			// $('html, body').animate({
			// 	scrollTop: pos.top
			// }, 0);
		} else {
			$('#ng-popover').width(popoverWidth);			
		}
		return pos;
	}

	// Hide popovers when pressing esc
	$('body').on('keyup', function(ev) {
		if(ev.keyCode === 27) {
			open = false;
			$('#ng-popover').fadeOut(200, function() {
				$(this).remove();
			});
		}
	});

	this.$get = ['$rootScope', '$templateCache', '$compile', function($rootScope, $templateCache, $compile) {
		return {

			close: function(data) {
				$rootScope.$broadcast('ng-popover-hide', data);
			}, 

			open : function(element, scope, options) {
				var setupClick = function() {
					scope.ngPopoverOptions = _.merge(getDefaultOptions(), scope.ngPopoverOptions, options);
					
					var template = $templateCache.get(scope.ngPopoverOptions.template ||scope.ngPopoverOptions.ngPopover);
					if (!template) {
						template = scope.ngPopoverOptions.template ||scope.ngPopoverOptions.ngPopover;
					}

					$('body').append("<div id='ng-popover' style='display:none'>" + 
										"<div class='arrow'></div>" + 
										( scope.ngPopoverOptions.title != '' ? "<div class='title'>" + scope.ngPopoverOptions.title + "</div>" : "" ) + 
										"<div class='content'>" + 
										template +
										"</div>" + 
										( scope.ngPopoverOptions.title != '' ? "<a href='' class='close-pop'>X</a>" : "" ) + 
									"</div>");
					$compile($('#ng-popover').contents())(scope);
					scope.$apply();

					
					var popoverPosition = calcPosition(element, scope.ngPopoverOptions.placement, scope.ngPopoverOptions.maximize, 
																scope.ngPopoverOptions.useParentWidth, scope.ngPopoverOptions.anchorSelector, 
																scope.ngPopoverOptions.maxWidth, scope.ngPopoverOptions.minWidth, 
																scope.ngPopoverOptions.width);
						

					$('.close-pop').on('click', function() {
						open = false;
						$('#ng-popover').fadeOut(200, function() {
							$(this).remove();
						});
					});

					var placementClass = scope.ngPopoverOptions.placement; 
					if (placementClass === 'bottom' && scope.ngPopoverOptions.title === '') {
						scope.ngPopoverOptions.placementClass = 'bottom-no-title';
					}

					$('#ng-popover')
						.css({
							left: popoverPosition.left, 
							top: popoverPosition.top
						})
						.toggleClass(placementClass)
						.fadeIn(100);

				}
 
				$(element).on('click', function(evt) {
					if(currentTarget != evt.target){
						scope.$broadcast('ng-popover-hide');
					}
					setTimeout(() => {
						if (!open) {
							open = true;
							currentTarget = evt.target;
							$rootScope.$broadcast('ng-popover-show', scope);
							setupClick();
						}
					}, 110);
				});

				scope.$on('ng-popover-hide', function() {
					open = false;
					$('#ng-popover').fadeOut(100, function() {
						$(this).remove();
					});
				});
			}
		}
	}]
});


module.directive('ngPopover', ['ngPopover', function(ngPopover) {
	return {
		restrict: 'A',
		scope: {
			options: '='
		},
		link: function(scope, element, attrs) {
			ngPopover.open(element, scope, attrs);
		}
	}
}]);